import type React from 'react';
import type { SVGProps } from 'react';

import { HelpOutlineIcon, RadarIcon, VolunteerActivismIcon } from '../components/AiSummaryCards/icons';

export type AiSummaryCardHeading = 'whats_happening' | 'why_it_matters' | 'the_ask';

export type AiSummaryCard = {
	icon: React.FC<SVGProps<SVGSVGElement>>;
	heading: AiSummaryCardHeading;
	description: string;
};

// Fixed per Figma (node 614:64030): icon + heading are static per card position,
// only the description comes from the AI-generated summary bullets.
const CARD_DEFINITIONS: ReadonlyArray<Pick<AiSummaryCard, 'icon' | 'heading'>> = [
	{ icon: HelpOutlineIcon, heading: 'whats_happening' },
	{ icon: VolunteerActivismIcon, heading: 'why_it_matters' },
	{ icon: RadarIcon, heading: 'the_ask' },
];

export function buildAiSummaryCards(bullets: readonly string[]): AiSummaryCard[] {
	return bullets.slice(0, CARD_DEFINITIONS.length).map((description, index) => ({
		...CARD_DEFINITIONS[index],
		description,
	}));
}
